/*
 *		Copyright (c) 2011-2015 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.ReturnPage')
    .factory('ReturnPageInterceptor', ['$q', '$window', '$location', 'ReturnPage', function($q, $window, $location, ReturnPage){
        return {
            responseError: function (rejection) {
                if (rejection.status === 401 && !rejection.config.ignoreUnauthenticatedErrors) {
                    ReturnPage.set($location.path());
                    $window.location.reload();
                }
                return $q.reject(rejection);
            }
        };
    }]);
